import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../rootSelectors';
import IPSView from '../../IPSView';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import {
    narrateStimulus, playResponseAudio, selectPossibleResponse, resetQuestionsAndTimeTrackingState,
    resetSelectedIndex,
} from '../../../common/questions/questionsActions';
import { setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { blockScreen, unblockScreen, unmountScreen } from '../../../common/screen/screenActions';
import { fetchIPSContent } from '../../ipsActions';
import { narrateStart, narrateReset, stopAudio } from '../../../common/audio/audioActions';
import { narrateQuestionsScreen, onNextButtonClick } from './IPSQuestionsActions';
import { getQuestionIndex } from '../../../common/utils/urlParsers';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import IPS_AUDIO_INSTRUCTIONS from '../../ipsConstants';
import { QUESTIONS } from '../../../constants/assessmentItemType';
import { IPS } from '../../../constants/measure';

const mapStateToProps = (state, ownProps) => {
    const props = multiChoiceUtils.mapStateToProps(state);
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        ...props,
        pageLayout: `${IPS.ASSESSMENT}`,
        isDataFetched: selectors.getIsIPSDataFetched(state),
        possibleResponses: selectors.getIPSPossibleResponses(state, QUESTIONS, questionIndex - 1),
        stimulusAudio: selectors.getIPSStimulusAudio(state, QUESTIONS, questionIndex - 1),
        stimulusImage: selectors.getIPSStimulusImage(state, QUESTIONS, questionIndex - 1),
        questionSpecificAudio: selectors.getIPSQuestionSpecificAudio(state, QUESTIONS,
            questionIndex - 1),
        playingResponseIndex: selectors.getPlayingResponseIndex(state),
        questionIndex,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        ...props,
        fetchContent: () => {
            dispatch(fetchIPSContent());
        },
        setAvatarInstructions: (questionSpecificAudio) => {
            dispatch(setAvatarInstructions([
                IPS_AUDIO_INSTRUCTIONS.questionsInstruction,
                questionSpecificAudio,
            ]));
        },
        narrateStimulus: (stimulusAudio) => {
            dispatch(narrateStimulus(stimulusAudio));
        },
        narrateScreen: async (questionSpecificAudio, stimulusAudio, possibleResponses) => {
            dispatch(blockScreen());
            dispatch(narrateStart());
            await dispatch(narrateQuestionsScreen(
                questionSpecificAudio,
                stimulusAudio,
                possibleResponses,
            ));
            dispatch(resetSelectedIndex());
            dispatch(narrateReset());
            dispatch(unblockScreen());
        },
        selectResponse: (index) => {
            dispatch(selectPossibleResponse(index));
            dispatch(onNextButtonClick(questionIndex));
        },
        responseAudioClick: async (audio, index) => {
            dispatch(blockScreen());
            await dispatch(playResponseAudio(audio, index));
            dispatch(unblockScreen());
        },
        cleanup: () => {
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetQuestionsAndTimeTrackingState());
            dispatch(unmountScreen());
        },
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.LOWER_LEFT,
});

const IPSQuestionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(IPSView);

export default IPSQuestionsContainer;
